module.exports = __webpack_public_path__ + "static/media/Client1.a817db83.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homeOperation/Client1.png
// module id = 522
// module chunks = 0